import styled from "styled-components/macro";

const TransparentContainer = styled.div`
  margin: 16px;
  padding: 24px;
`;

export default TransparentContainer;
